import { Configuration } from "@azure/msal-browser";
import { FilePickerOptions } from "~/sharedComponents/msFilePicker";
import { QtipProps } from "~/sharedComponents/tooltip";

export const MESSAGE_EDITOR_CONTAINER = "js-message-editor";

export const newMessageActionsQTipOptions: QtipProps = {
    showFocus: true,
    position: {
        my: "bottom center",
        at: "top center",
    },
};

export const sharepointPickerParams: FilePickerOptions = {
    sdk: "8.0",
    entry: {
        sharePoint: {},
    },
    authentication: {},
    messaging: {
        origin: location.origin,
        channelId: "27",
    },
    selection: {
        mode: "multiple",
    },
    typesAndSources: {
        mode: "files",
        pivots: {
            recent: false,
            oneDrive: false,
            sharedLibraries: true,
            search: true,
        },
    },
};

export const sharepointMsalParams: Configuration = {
    auth: {
        authority: "https://login.microsoftonline.com/common/",
        clientId: "893243c6-0271-4add-8941-3193d3ccbcd5",
        redirectUri: "https://oauthproxy.go.easyprojects.net/return",
    },
};

export const oneDrivePickerParams: FilePickerOptions = {
    sdk: "8.0",
    entry: {
        oneDrive: {},
    },
    authentication: {},
    messaging: {
        origin: location.origin,
        channelId: "27",
    },
    selection: {
        mode: "multiple",
    },
    typesAndSources: {
        mode: "files",
        pivots: {
            recent: true,
            oneDrive: true,
            sharedLibraries: true,
            search: true,
        },
    },
};
export const oneDriveMsalParams: Configuration = {
    auth: {
        authority: "https://login.microsoftonline.com/common/",
        clientId: "d51c70f8-669a-42b8-be66-e17303743b9a",
        redirectUri: "https://oauthproxy.go.easyprojects.net/return",
    },
};
